module.exports = __webpack_public_path__ + "img/mini-qrcode.0320e842.jpg";